import { LocationStrategy, HashLocationStrategy, APP_BASE_HREF } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { AppComponent } from "./app.component";
import { PreloadAllModules, RouterModule } from "@angular/router";
import { HttpClientModule } from "@angular/common/http";
import { httpInterceptorProviders } from "./_interceptors";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ReactiveFormsModule } from "@angular/forms";

import { LayoutModule } from "./layout/layout.module";
import { SharedModule } from "./_shared/shared.module";

import { ComingSoonComponent } from "./coming-soon/coming-soon.component";
import { NgChartjsModule } from "ng-chartjs";
import { ResponseData } from "./_pipes/reponse-data.pipe";
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

@NgModule({
  declarations: [AppComponent, ComingSoonComponent, ResponseData, UnauthorizedComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: "toast-bottom-center",
      preventDuplicates: true,
      progressBar: true,
    }),
    HttpClientModule,
    NgbModule,
    RouterModule.forRoot([], {
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "top",
      preloadingStrategy: PreloadAllModules,
    }),
    SharedModule,
    ReactiveFormsModule,
    LayoutModule,
    NgChartjsModule.registerPlugin([]),
  ],
  exports: [],
  providers: [
    httpInterceptorProviders,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: APP_BASE_HREF, useValue: "relay" },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
